"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = {
    key: 0,
    class: "calendar-container"
};
const vue_3 = require("vue");
const FullCalendarComponent_vue_1 = __importDefault(require("../../../../components/backend/FullCalendarComponent.vue"));
const CalendarFooter_vue_1 = __importDefault(require("../footer/CalendarFooter.vue"));
const serviceBaysStore_1 = require("../../../../stores/backend/serviceBays/serviceBaysStore");
const CompanyLocationStore_1 = require("../../../../stores/backend/company/CompanyLocationStore");
const bookedAppointmentsStore_1 = require("../../../../stores/backend/bookedAppointments/bookedAppointmentsStore");
const appointmentStore_1 = require("../../../../stores/appointment/appointmentStore");
const ReservationModal_vue_1 = __importDefault(require("../modal/ReservationModal.vue"));
const addDays_1 = __importDefault(require("date-fns/addDays"));
const toastStore_1 = require("../../../../stores/toast/toastStore");
const i18n_1 = __importDefault(require("../../../../common/i18n"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ReservationCalendar',
    setup(__props) {
        const freeAppointmentsStore = (0, appointmentStore_1.useAppointmentStore)();
        const appointmentsStore = (0, bookedAppointmentsStore_1.useBookedAppointmentsStore)();
        const companyLocationStore = (0, CompanyLocationStore_1.useCompanyLocationStore)();
        const serviceBaysStore = (0, serviceBaysStore_1.useServiceBaysStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const modalOpen = (0, vue_3.ref)(false);
        const renderKey = (0, vue_3.ref)(0);
        const passAppointment = (0, vue_3.ref)(null);
        const calendarMarkers = (0, vue_3.ref)([]);
        const serviceBaysWithAppointments = (0, vue_3.computed)(() => {
            return serviceBaysStore.serviceBays.map((serviceBay) => ({
                ...serviceBay,
                appointments: appointmentsStore.getAppointmentsByServiceBayId(serviceBay.id, appointmentsStore.selectedDate),
            }));
        });
        const closeModal = () => {
            modalOpen.value = false;
            appointmentsStore.detaildAppointment = null;
        };
        const selectAppointment = async (event) => {
            var _a;
            //modalOpen.value = true;
            await appointmentsStore.getDetaildAppointment((_a = companyLocationStore.selectedLocation) === null || _a === void 0 ? void 0 : _a.id, parseInt(event.id));
            passAppointment.value = appointmentsStore.detaildAppointment;
            modalOpen.value = true;
        };
        const changeYearOrMonth = async (year, month, locationId, serviceId) => {
            await freeAppointmentsStore.getAppointments(year, month, locationId, serviceId);
            calendarMarkers.value = [];
            Object.entries(freeAppointmentsStore.dates).forEach(([index, value]) => {
                //console.log(index);
                let color = "grey";
                let tooltip = i18n_1.default.trans("calendar_no_open", "Color meaning: don't have opening time in that day", "vuepic_calendar");
                if (value.status == "0") {
                    color = "green";
                    tooltip = i18n_1.default.trans("calendar_has_enough_time", "Color meaning: this day has enough time to paste this appointment", "vuepic_calendar");
                }
                else if (value.status === "full") {
                    color = "red";
                    tooltip = i18n_1.default.trans("calendar_no_appointment", "Color meaning: no free appointments in that day", "vuepic_calendar");
                }
                calendarMarkers.value.push({
                    date: (0, addDays_1.default)(new Date(year +
                        "-" +
                        String(month + 1).padStart(2, "0") +
                        "-" +
                        String(value.monthDay).padStart(2, "0")), 0),
                    type: "line",
                    color: color,
                    tooltip: [
                        {
                            text: tooltip,
                            color: color,
                        },
                    ],
                });
            });
        };
        const getDateFromCalendar = (date) => {
            appointmentsStore.selectedDate = date;
        };
        const createNewAppointment = (startDate, serviceBay, locationId) => {
            passAppointment.value = {
                bayId: serviceBay,
                plate_number: "",
                car_make_slug: "",
                car_model_slug: "",
                car_type_slug: "",
                car_make: "",
                car_model: "",
                car_type: "",
                car_year: 0,
                comment: "",
                is_wheel: false,
                booked_date: startDate,
                booked_time: startDate,
                source: "service",
                sourceColor: "",
                created_at: "",
                bayName: "",
                email: "",
                status: "",
                statusId: 0,
                duration: 0,
                invoice: "",
                is_runflat: false,
                is_stored: false,
                is_tpms: false,
                name: "",
                phone: "",
                rim_size: 0,
                serviceId: 0,
                service_duration: 0,
                service_name: "",
                tyre_type: "",
                locationId: locationId,
            };
            modalOpen.value = true;
        };
        const pasteEventAfter = async (id, newStart, newEnd, serviceBayId) => {
            await appointmentsStore.pasteEvent(parseInt(id), newStart, newEnd, serviceBayId);
            if (companyLocationStore.selectedLocation) {
                await appointmentsStore.getAppointmentsForClendar(companyLocationStore.selectedLocation.id, appointmentsStore.selectedDate);
            }
            renderKey.value++;
        };
        let loading = (0, vue_3.ref)(true);
        const loadData = async (newSelectedLocation) => {
            if (newSelectedLocation !== null && appointmentsStore.selectedDate) {
                await serviceBaysStore.getServiceBays(newSelectedLocation.id);
                await appointmentsStore.getAppointmentsForClendar(newSelectedLocation.id, appointmentsStore.selectedDate);
            }
            loading.value = false;
        };
        (0, vue_3.onMounted)(() => {
            appointmentsStore.readSelectedDate();
            loadData(companyLocationStore.selectedLocation);
            (0, vue_3.watch)(() => [companyLocationStore.selectedLocation], ([newSelectedLocation]) => {
                if (newSelectedLocation !== null) {
                    loading.value = true;
                    loadData(newSelectedLocation);
                }
            }, { immediate: false });
            (0, vue_3.watch)(() => [appointmentsStore.selectedDate], ([newDate]) => {
                if (newDate) {
                    loading.value = true;
                    loadData(companyLocationStore.selectedLocation);
                    appointmentsStore.saveSelectedDate();
                }
            }, { immediate: false });
        });
        const acceptAppointment = async (appointmentId) => {
            await appointmentsStore.acceptAppointment(appointmentId);
            passAppointment.value = appointmentsStore.detaildAppointment;
            renderKey.value++;
        };
        const declineAppointment = async (appointmentId) => {
            await appointmentsStore.declineAppointment(appointmentId);
            passAppointment.value = appointmentsStore.detaildAppointment;
            renderKey.value++;
        };
        const deleteAppointment = async (appointmentId) => {
            await appointmentsStore.deleteAppointment(appointmentId);
            passAppointment.value = appointmentsStore.detaildAppointment;
            closeModal();
            renderKey.value++;
        };
        const saveAppointment = async (appointment) => {
            await appointmentsStore
                .saveAppointment(appointment)
                .then(async () => {
                if (companyLocationStore.selectedLocation) {
                    await appointmentsStore.getAppointmentsForClendar(companyLocationStore.selectedLocation.id, appointmentsStore.selectedDate);
                }
                appointmentsStore.selectedDate = appointment.booked_date;
                closeModal();
                renderKey.value++;
            })
                .catch((error) => {
                toastStore.addFadingErrorToast(error.toString());
            });
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (!(0, vue_2.unref)(loading) && (0, vue_2.unref)(appointmentsStore).selectedDate)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(serviceBaysWithAppointments.value, (serviceBay) => {
                                var _a, _b;
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(FullCalendarComponent_vue_1.default, {
                                    key: String(serviceBay.id) + String(renderKey.value),
                                    class: "calendar",
                                    title: serviceBay.public
                                        ? serviceBay.name
                                        : `${serviceBay.name} (${_ctx.$trans('private_service_bay', 'Private', 'reservation_calendar')})`,
                                    appointments: serviceBay.appointments,
                                    "service-bay-id": serviceBay.id,
                                    "calendar-markers": calendarMarkers.value,
                                    "selected-date": (0, vue_2.unref)(appointmentsStore).selectedDate,
                                    "location-id": (_b = (_a = (0, vue_2.unref)(companyLocationStore).selectedLocation) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0,
                                    onClickEvent: selectAppointment,
                                    onPasteEventAfter: pasteEventAfter,
                                    onGetSelectedDate: getDateFromCalendar,
                                    onCalendarHandleMonthYear: changeYearOrMonth,
                                    onCreateNewAppointment: createNewAppointment
                                }, null, 8, ["title", "appointments", "service-bay-id", "calendar-markers", "selected-date", "location-id"]));
                            }), 128))
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(ReservationModal_vue_1.default, {
                        "is-open": modalOpen.value,
                        "appointment-datas": passAppointment.value,
                        onClose: closeModal,
                        onApproveAppointment: acceptAppointment,
                        onDeclineAppointment: declineAppointment,
                        onDeleteAppointment: deleteAppointment,
                        onSaveAppointment: saveAppointment
                    }, null, 8, ["is-open", "appointment-datas"])
                ]),
                (0, vue_2.createVNode)(CalendarFooter_vue_1.default)
            ], 64));
        };
    }
});
